/**
 * Blocs de chargement.
 *
 * Le probleme n'etait pas seulement une page blanche. Le tableau de bord
 * affichait des ZEROS en attendant ses donnees : « 0 véhicule en parc » pour
 * une flotte de 108 camions, « 0,00 € » de coût total. Sur une connexion lente
 * -- un exploitant sur son téléphone en bord de quai -- ces zéros restent
 * plusieurs secondes et se lisent comme un résultat, pas comme une attente.
 *
 * Un squelette dit la vérité : « quelque chose arrive, voici sa forme ». Il
 * évite aussi le sursaut de la page qui se remplit d'un coup, puisque la place
 * est déjà prise.
 *
 * L'animation vit dans App.css : une image-clé ne s'écrit pas dans un attribut
 * style. Elle s'efface pour qui a demandé à réduire les animations dans son
 * système.
 */

/** Bloc gris de dimensions libres. */
export function Bloc({ largeur = "100%", hauteur = 12, rayon = 4 }) {
  return (
    <div
      className="squelette"
      style={{ width: largeur, height: hauteur, borderRadius: rayon }}
    />
  );
}

/** Rangée de cartes d'indicateur, à la forme de celles du tableau de bord. */
export function SqueletteIndicateurs({ nombre = 4 }) {
  return (
    <div className="grille-indicateurs">
      {Array.from({ length: nombre }, (_, i) => (
        <div key={i} className="carte-indicateur carte-squelette">
          <Bloc largeur="55%" hauteur={10} />
          <Bloc largeur="40%" hauteur={24} />
        </div>
      ))}
    </div>
  );
}

/** Lignes de tableau, alignées sur le nombre de colonnes affichées. */
export function SqueletteTableau({ lignes = 6, colonnes = 5 }) {
  return (
    <tbody>
      {Array.from({ length: lignes }, (_, i) => (
        <tr key={i}>
          {Array.from({ length: colonnes }, (_, j) => (
            <td key={j}>
              {/* Largeurs inégales : des blocs tous identiques font grille de
                  mots croisés, pas tableau en cours de chargement. */}
              <Bloc largeur={["70%", "55%", "45%", "65%", "35%"][j % 5]} hauteur={11} />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}

/** Suite de cartes, pour une liste de véhicules ou d'échéances. */
export function SqueletteCartes({ nombre = 4 }) {
  return (
    <div className="squelette-cartes">
      {Array.from({ length: nombre }, (_, i) => (
        <div key={i} className="carte carte-squelette">
          <Bloc largeur="30%" hauteur={14} />
          <Bloc largeur="60%" hauteur={11} />
        </div>
      ))}
    </div>
  );
}

export default Bloc;
